import { render, staticRenderFns } from "./ComponentProjects.vue?vue&type=template&id=0fc7cee5&"
import script from "./ComponentProjects.vue?vue&type=script&lang=js&"
export * from "./ComponentProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports